/* Homepage demo interactions: scroll reveal, collection tabs, mobile menu, mood switch.
   Plain DOM, no dependencies, so every piece ports 1:1 into a theme asset later. */
(function () {
  'use strict';

  // 1. Scroll reveal: fade sections in once, as they enter the viewport
  var revealTargets = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    revealTargets.forEach(function (el) { observer.observe(el); });
  } else {
    revealTargets.forEach(function (el) { el.classList.add('is-in'); });
  }

  // 2. Collection tabs on the shelf (click + arrow keys), and keep the "see all" link in sync
  var tabs = Array.prototype.slice.call(document.querySelectorAll('.tabs__tab'));
  var moreLink = document.getElementById('shelf-more');
  function selectTab(tab) {
    tabs.forEach(function (other) {
      var active = other === tab;
      var panel = document.getElementById(other.getAttribute('aria-controls'));
      if (!panel) return;
      other.setAttribute('aria-selected', String(active));
      other.tabIndex = active ? 0 : -1;
      panel.hidden = !active;
      if (active && moreLink) {
        panel.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); });
        moreLink.href = panel.dataset.more;
        moreLink.querySelector('span').textContent = panel.dataset.moreLabel;
      }
    });
  }
  tabs.forEach(function (tab, index) {
    tab.addEventListener('click', function () { selectTab(tab); });
    tab.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
      var step = event.key === 'ArrowRight' ? 1 : -1;
      var next = tabs[(index + step + tabs.length) % tabs.length];
      next.focus();
      selectTab(next);
    });
  });

  // 3. Mobile menu toggle
  var menuButton = document.querySelector('.masthead__menu');
  var nav = document.getElementById('site-nav');
  if (menuButton && nav) {
    menuButton.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      menuButton.setAttribute('aria-expanded', String(open));
      menuButton.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    });
  }

})();

/* Biggest sale landing (13 to 15 Nov 2026): one clock, three states, arrival dates, sticky bar.
   The two moments of the sale come from the #sale-data JSON embedded at assembly time (UTC), never from the
   visitor's clock settings. States: "pre" counts down to the doors opening, "open" counts down to the end,
   "closed" hides every sale price and sends the buttons to the regular shop. ?state=pre|open|closed previews
   a state for review; it never changes a price on the store, only what this page says. */
(function () {
  'use strict';
  var node = document.getElementById('sale-data');
  if (!node) return; // not the sale landing
  var data = JSON.parse(node.textContent);
  var opens = Date.parse(data.opens), ends = Date.parse(data.ends);
  var root = document.documentElement;
  var each = function (selector, fn) { Array.prototype.forEach.call(document.querySelectorAll(selector), fn); };
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  var override = /[?&]state=(pre|open|closed)\b/.exec(window.location.search);
  var state = null;

  function stateAt(now) {
    if (override) return override[1];
    return now < opens ? 'pre' : now < ends ? 'open' : 'closed';
  }

  function setState(next) {
    if (next === state) return;
    state = next;
    root.setAttribute('data-sale-state', state);
    if (state !== 'closed') return;
    each('[data-offer]', function (el) { el.hidden = true; });
    each('[data-price]', function (el) { el.textContent = el.dataset.price; });
    each('[data-cta]', function (el) {
      el.textContent = 'Shop at the regular price';
      el.setAttribute('href', data.store + '/collections/all');
    });
  }

  // 1. The clock. In "pre" it counts to the opening, in "open" to the end; at zero the state moves on by itself.
  function tick() {
    var now = Date.now();
    setState(stateAt(now));
    var target = state === 'pre' ? opens : ends;
    var left = Math.max(0, target - now);
    if (override && left === 0) left = 2 * 86400000 + 5 * 3600000; // a frozen demo value when a past state is previewed
    var parts = { days: Math.floor(left / 86400000), hours: Math.floor(left / 3600000) % 24, minutes: Math.floor(left / 60000) % 60, seconds: Math.floor(left / 1000) % 60 };
    each('[data-countdown] [data-unit]', function (el) { el.textContent = pad(parts[el.dataset.unit]); });
    each('[data-countdown-inline]', function (el) { el.textContent = parts.days + 'd ' + pad(parts.hours) + 'h ' + pad(parts.minutes) + 'm ' + pad(parts.seconds) + 's'; });
  }
  tick();
  window.setInterval(tick, 1000);

  // 2. Estimated arrival, as dates in Pacific time, from the shipping promise of the store (an estimate, labelled as one)
  var day = 86400000, now = Date.now();
  var pacific = function (date) { return date.toLocaleDateString('en-US', { timeZone: 'America/Los_Angeles', month: 'short', day: 'numeric' }); };
  var from = pacific(new Date(now + data.eta.fast * day)), to = pacific(new Date(now + data.eta.slow * day));
  each('[data-eta-sentence]', function (el) { el.textContent = 'Ordered today, it is estimated to arrive between ' + from + ' and ' + to + '.'; });

  // 3. Sticky bar: appears after the hero, steps aside while the lines are on screen
  var bar = document.getElementById('lp-bar'), lines = document.getElementById('lines');
  if (bar && lines) {
    var ticking = false;
    var updateBar = function () {
      var rect = lines.getBoundingClientRect();
      var linesOnScreen = rect.top < window.innerHeight * 0.6 && rect.bottom > window.innerHeight * 0.4;
      bar.hidden = window.scrollY < 600 || linesOnScreen;
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(updateBar); }
    }, { passive: true });
    updateBar();
  }
})();
